import React, { useState } from "react";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Divider from "@material-ui/core/Divider";
import { colors, Hidden, Paper } from "@material-ui/core";
import { useStylesLbl, useStylesTF } from "../../../../St/comps/UseStyle";
import { SharedGroupIdProvider } from "../../../Invs/BackEnd/InvoiceRest/RestProductsG";
import GroupLists from "../../../Invs/BackEnd/InvoiceRest/GroupLists";
import { GroupSelectRest } from "../../../Invs/BackEnd/POS/GroupSelectRest";
import { permOtherSafes,  permSafes, permSales } from "../checksPermmision";
import CheckboxItems, { useStylesAccs } from "../CheckBoxComponents";

export default function SafesPermission(props) {
    const { onChange, object,  viewHandle,formsData,setFormsData } = props;
    const typeSetting = [
        { id: 0, name: "مخزون أول المـدة",Form_id:40005, color: -1 },
        { id: 1, name: "التوريد المخزني", Form_id:70007,color: -1 },
        { id: 2, name: "الصرف المخزني",Form_id:70008, color: -1 },
        { id: 3, name: "التحويل المخزني",Form_id:70009, color: -1 },
    ];

    const classes = useStylesAccs();
    const [saleSetting, setSaleSetting] = useState(typeSetting[0]);
    const [selectColor, setSelectColor] = useState({ id: 0, color: colors.blue[300] });
// 
    const clasTF = useStylesTF();
    const claslbl = useStylesLbl();
    const onRowClick = (row) => {
        setSaleSetting(row);
        setSelectColor({ ...row, color: colors.blue[300] });
        setFormsData({...formsData,Form_id:row.Form_id});
        viewHandle(formsData.user.id,row.Form_id);
    };
    return (
        <div className={classes.root}>
            <Accordion expanded={true}>

                <Grid item xs={12} container spacing={0} >

                    <Grid item lg={2} md={2} sm={12} xs={12}>
                        <Hidden smDown>
                            <Paper
                                style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
                            >
                                <SharedGroupIdProvider>
                                    <GroupLists
                                        groups={[...typeSetting]}
                                        onRowClick={onRowClick}
                                        isMain={true}
                                        GroupColor={selectColor}
                                    />
                                    <Divider />
                                </SharedGroupIdProvider>
                            </Paper>
                        </Hidden>
                        <Hidden mdUp>
                            <GroupSelectRest
                                groups={[...typeSetting]}
                                onRowClick={onRowClick}
                                isMain={true}
                                GroupColor={selectColor}
                            />
                        </Hidden>
                    </Grid>

                    <Grid item lg={10} md={10} sm={12} xs={12}>
                        <div
                            style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
                        >
                            <SharedGroupIdProvider>
                                {saleSetting.id == 0 ?
                                    <>
                                        <AccordionDetails className={classes.subTitle}>
                                        </AccordionDetails>

                                        <AccordionDetails >
                                            <Grid item container spacing={1}>
                                                {permSafes
                                                    ?.filter((d) => d.visible)
                                                    ?.map((item) => {
                                                        return (
                                                            <Grid xs={6}>
                                                                <CheckboxItems
                                                                    value={object[item.name] ?? null}
                                                                    name={item.name}
                                                                    label={item.label}
                                                                    onChange={onChange}
                                                                />
                                                            </Grid>
                                                        );
                                                    })}
                                            </Grid>
                                        </AccordionDetails>
                                        <Divider className={classes.divider} />
                                    </>
                                    :

                                        <AccordionDetails >
                                            <Grid item container spacing={1}>
                                                {permOtherSafes(saleSetting.id)
                                                    ?.filter((d) => d.visible)
                                                    ?.map((item) => {
                                                        return (
                                                            <Grid xs={6}>
                                                                <CheckboxItems
                                                                    value={object[item.name] ?? null}
                                                                    name={item.name}
                                                                    label={item.label}
                                                                    onChange={onChange}
                                                                />
                                                            </Grid>
                                                        );
                                                    })}
                                            </Grid>
                                        </AccordionDetails>
                                }

                            </SharedGroupIdProvider>
                        </div>
                    </Grid>
                </Grid>
            </Accordion>
            <Swipeable />
        </div>
    );
}
